import React from 'react';
import './DownloadProgressModal.css';

const DownloadProgressModal = ({ open, percent, message, error, onClose }) => {
  if (!open) return null;

  const isDone = percent >= 100 && !error;

  return (
    <div className="dpm-overlay" onClick={error || isDone ? onClose : undefined}>
      <div className="dpm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close button — only when error or done */}
        {(error || isDone) && (
          <button className="dpm-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        )}

        {/* Icon */}
        <div className={`dpm-icon ${error ? 'dpm-icon-error' : isDone ? 'dpm-icon-done' : 'dpm-icon-loading'}`}>
          {error ? (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
          ) : isDone ? (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 12 15 16 10"/></svg>
          ) : (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="dpm-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
          )}
        </div>

        <h3 className="dpm-title">
          {error ? 'Generation Failed' : isDone ? 'PDF Ready!' : 'Generating PDF...'}
        </h3>

        <p className="dpm-message">{error || message || 'Preparing your resume...'}</p>

        {/* Progress bar */}
        {!error && (
          <div className="dpm-bar-track">
            <div
              className="dpm-bar-fill"
              style={{ width: `${Math.min(percent, 100)}%` }}
            />
          </div>
        )}

        {!error && <span className="dpm-percent">{Math.round(percent)}%</span>}
      </div>
    </div>
  );
};

export default DownloadProgressModal;
